import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Tag,
  Form,
  Button,
  Space,
  Modal,
  Spin,
  Descriptions,
  Card,
  Popconfirm,
  message,
  Checkbox,
  Select,
  Tooltip,
  Dropdown,
  DatePicker,
  Radio,
} from "antd";
import { Helmet } from "react-helmet";
import { Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useLocation, useNavigate } from "react-router-dom";
import RequirePermission from "../components/Common/RequirePermission";
import LocationFilter from "../components/Common/LocationFilter";
import CityFilter from "../components/Common/CityFilter";
import ClearFiltersButton from "../components/Common/ClearFiltersButton";
import PreviewPlaylist from "../components/Playlists/PreviewPlaylist";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseOutlined,
  DownOutlined,
  DisconnectOutlined,
  ExclamationCircleOutlined,
  DatabaseOutlined,
  FilterOutlined,
  ReloadOutlined,
  SyncOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import DeviceForm from "../components/Devices/DeviceForm";

dayjs.extend(utc);
dayjs.extend(timezone);

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const obj = {
  0: "Landscape Primary",
  180: "Landscape Secondary",
  90: "Portrait Primary",
  270: "Portrait Secondary",
};

const formatIST = (date) =>
  date ? dayjs(date).tz("Asia/Kolkata").format("DD-MM-YYYY HH:mm:ss") : "-";

const Devices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [viewPermission, setViewPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [user, setUser] = useState(null);
  const [detail, setDetail] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [editingDevice, setEditingDevice] = useState(null);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [playlists, setPlaylists] = useState([]);
  const [screens, setScreens] = useState([]);
  const [assignableScreens, setAssignableScreens] = useState([]);
  const [locations, setLocations] = useState([]);
  const [facilities, setFacilities] = useState({ type: "flat", locations: [] });
  const [cities, setCities] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [assignScreenModalOpen, setAssignScreenModalOpen] = useState(false);
  const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [currentScreen, setCurrentScreen] = useState(null);
  const [assignPlaylistModalOpen, setAssignPlaylistModalOpen] = useState(false);
  const [assignScreenSingleModalOpen, setAssignScreenSingleModalOpen] =
    useState(false);
  const [screenOptions, setScreenOptions] = useState([]);
  const [screenSearch, setScreenSearch] = useState("");
  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logs, setLogs] = useState([]);
  const [totalLogRecords, setTotalLogRecords] = useState(0);
  const [logPageSize, setLogPageSize] = useState(10);
  const [logCurrentPage, setLogCurrentPage] = useState(1);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [eventFilter, setEventFilter] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [typeSearch, setTypeSearch] = useState("");
  const [onlineSearch, setOnlineSearch] = useState("");
  const [blockedSearch, setBlockedSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [orientationSearch, setOrientationSearch] = useState("");
  const [isForceOrientation, setIsForceOrientation] = useState("");
  const [isForceOrientationPosition, setIsForceOrientationPosition] =
    useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [deviceTab, setDeviceTab] = useState("all");
  const [unassignedTotal, setUnassignedTotal] = useState(0);
  const [syncing, setSyncing] = useState(false);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [mergeSourceDevice, setMergeSourceDevice] = useState(null);
  const [mergeCandidates, setMergeCandidates] = useState([]);
  const [mergeCandidatesLoading, setMergeCandidatesLoading] = useState(false);
  const [selectedMergeTarget, setSelectedMergeTarget] = useState(null);
  const [mergeSubmitting, setMergeSubmitting] = useState(false);
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewingPlaylistId, setPreviewingPlaylistId] = useState(null);

  const device_logs = "Device Logs";
  const setQueryParams = (params) => {
    const searchParams = new URLSearchParams(params);
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setFilterText(value);
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: value,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleScreenChange = (value) => {
    setScreenSearch(value || "");
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: value,
      city: citySearch || "",
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleTypeChange = (value) => {
    setTypeSearch(value || "");
    const newQueryParams = {
      type: value || "",
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleOnlineChange = (value) => {
    setOnlineSearch(value || "");
    const newQueryParams = {
      online: value,
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleBlockedChange = (value) => {
    setBlockedSearch(value || "");
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: value,
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleCityChange = (value) => {
    setCitySearch(value || "");
    const filteredLocations = locations
      .filter((location) => location.city_id === value)
      .map((location) => ({
        id: location.id,
        name: location.name,
      }));
    if (filteredLocations.length === 0) {
      setLocationOptions(locations);
    } else {
      setLocationOptions(filteredLocations);
    }
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: value,
      location: locationSearch || "",
      orientation: orientationSearch || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleOrientationChange = (value) => {
    setOrientationSearch(value || "");
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      location: locationSearch || "",
      orientation: value || "",
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setFilterText("");
    setScreenSearch("");
    setTypeSearch("");
    setOnlineSearch("");
    setBlockedSearch("");
    setCitySearch("");
    setLocationSearch("");
    setOrientationSearch("");
    setLocationOptions(locations);
    setCurrentPage(1);
    setQueryParams({
      online: "",
      blocked: "",
      screen: "",
      type: "",
      city: "",
      location: "",
      orientation: "",
      filter: "",
      limit: pageSize,
      page: 1,
    });
  };

  const handleLocationChange = (value) => {
    if (value === "") {
      message.warning("Please select a city first.");
    }
    setLocationSearch(value || "");
    const newQueryParams = {
      online: onlineSearch || "",
      blocked: blockedSearch || "",
      screen: screenSearch || "",
      city: citySearch || "",
      orientation: orientationSearch || "",
      location: value,
      filter: filterText,
      limit: pageSize,
      page: 1,
    };

    setQueryParams(newQueryParams);
    setCurrentPage(1);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    // if (typeof sorter.order === "undefined") {
    //   setSortingOrder("desc");
    //   setSortingColumn("id");
    // } else {
    //   setSortingColumn(sorter.field);
    //   setSortingOrder(sorter.order === "ascend" ? "asc" : "desc");
    // }
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const handleLogTableChange = (pagination) => {
    const { current, pageSize } = pagination;

    // Update state
    setLogCurrentPage(current);
    setLogPageSize(pageSize);

    // Fetch data with new pagination
    if (selectedDeviceId) {
      fetchLogs(selectedDeviceId, current, pageSize);
    }
  };

  const handleForceOrientationChange = (e) => {
    const value = e.target.value;
    setIsForceOrientation(value);
    if (value === "no") {
      setIsForceOrientationPosition(null);
    }
  };

  const handleForceOrientationPositionChange = (value) => {
    setIsForceOrientationPosition(value);
  };

  const handleSelectAllChecked = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    const checked = e.target.checked;
    const newSelectedDevices = {};
    devices.forEach((device) => {
      newSelectedDevices[device.id] = checked;
    });

    setSelectedDevices(newSelectedDevices);
    setIsSelectAllChecked(checked);
  };

  const handleSingleCheckboxChange = (e, deviceId) => {
    e.stopPropagation(); // Prevent event bubbling
    const newSelectedDevices = {
      ...selectedDevices,
      [deviceId]: e.target.checked,
    };
    setSelectedDevices(newSelectedDevices);
    // Check if all checkboxes are selected (only count devices that exist)
    const totalDevices = devices.length;
    const selectedCount =
      Object.values(newSelectedDevices).filter(Boolean).length;
    const allSelected = totalDevices > 0 && selectedCount === totalDevices;
    setIsSelectAllChecked(allSelected);
  };

  const handleEdit = (record) => {
    setIsModalOpen(true);
    setEditingDevice(record);
  };

  const handleAssign = (record) => {
    setAssignPlaylistModalOpen(true);
    setSelectedPlaylist(record.playlist_id || null);
    setCurrentPlaylist(record.playlist_id || null);
    setSelectedDevice([record.id]);
  };

  const handleScreen = (record) => {
    setAssignScreenSingleModalOpen(true);
    setSelectedScreen(record.screen_id || null);
    setCurrentScreen(record.screen_id || null);
    setSelectedDevice([record.id]);
  };

  const handleDelete = async (record) => {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BASE_URL + `/api/devices/${record.id}`,
      );
      const updated_row_count = response.data.data.updated_row_count;
      await fetchData();
      if (updated_row_count === 1) {
        message.success("Screen deleted");
      }
    } catch (error) {
      console.error("Error deleting screen", error);
    }
  };

  // Previews the ASSIGNED SCREEN's own playlist (record.screen_playlist_id)
  // - what playSync actually resolves and serves to a connected device -
  // not record.playlist_id, which is this device's own separate ad-hoc
  // override (see the "Playlist" column/handleAssign) and isn't what
  // determines real playback. Mirrors Screens.jsx's identical
  // handlePreviewPlaylist for a screen's own playlist_id.
  const handlePreviewPlaylist = async (record) => {
    if (!record.screen_playlist_id) return;
    setPreviewLoading(true);
    setPreviewingPlaylistId(record.screen_playlist_id);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/playlists/${record.screen_playlist_id}`
      );
      const playlist = response.data.data;
      setPreviewPlaylist({
        ...playlist,
        media: JSON.parse(playlist.media_details),
      });
      setIsPreviewModalOpen(true);
    } catch (error) {
      message.error("Failed to load playlist preview");
      console.error("Error fetching playlist for preview:", error);
    } finally {
      setPreviewLoading(false);
      setPreviewingPlaylistId(null);
    }
  };

  const handleOpenMerge = async (record) => {
    setMergeSourceDevice(record);
    setSelectedMergeTarget(null);
    setMergeModalOpen(true);
    setMergeCandidatesLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/devices/${record.id}/merge-candidates`,
      );
      setMergeCandidates(response.data.data || []);
    } catch (error) {
      console.error("Error fetching merge candidates", error);
      message.error("Failed to load devices to combine with");
    } finally {
      setMergeCandidatesLoading(false);
    }
  };

  const handleCloseMerge = () => {
    setMergeModalOpen(false);
    setMergeSourceDevice(null);
    setMergeCandidates([]);
    setSelectedMergeTarget(null);
  };

  const handleConfirmMerge = async () => {
    if (!selectedMergeTarget || !mergeSourceDevice) return;
    setMergeSubmitting(true);
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/devices/merge`, {
        old_device_id: mergeSourceDevice.id,
        new_device_id: selectedMergeTarget,
      });
      message.success("Devices combined successfully");
      handleCloseMerge();
      await fetchData();
    } catch (error) {
      console.error("Error combining devices", error);
      message.error(
        error.response?.data?.message || "Failed to combine devices",
      );
    } finally {
      setMergeSubmitting(false);
    }
  };

  const handleView = async (record) => {
    try {
      setLoading(true);
      setIsViewModalOpen(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices/${record.id}`,
      );
      setDetail(response.data.data);
      setIsForceOrientation(
        record.is_force_orientation === null
          ? "no"
          : record.is_force_orientation,
      );
      setIsForceOrientationPosition(record.force_orientation_position);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching screen data", error);
    }
  };

  const handleOpenMap = async (lat, lng) => {
    try {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      window.open(url, "_blank");
    } catch (error) {
      message.error("Error opening map");
      console.error("Error fetching screen data", error);
    }
  };

  const handleLogs = async (record) => {
    try {
      setLoading(true);
      setLogsModalOpen(true);
      setSelectedDeviceId(record.id);
      await fetchLogs(record.id, logCurrentPage, logPageSize);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching screen data", error);
    }
  };

  const fetchLogs = async (
    deviceId,
    page = logCurrentPage,
    limit = logPageSize,
  ) => {
    try {
      setLoading(true);
      const params = {
        limit,
        page,
      };

      if (eventFilter) {
        params.event = eventFilter;
      }

      if (dateRange.length === 2) {
        params.startDate = dateRange[0].format("YYYY-MM-DD");
        params.endDate = dateRange[1].format("YYYY-MM-DD");
      }

      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices/${deviceId}/logs`,
        { params },
      );

      let records = response.data.data.data;
      setTotalLogRecords(response.data.data.total);
      setLogs(records);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching logs data", error);
    }
  };

  const handleDisconnect = async (record) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/api/disconnect`,
        {
          device_ids: [record.id],
        },
      );
      const { updated_row_count, message: responseMessage } =
        response.data.data;

      await fetchData();
      if (updated_row_count === 1) {
        message.success("Device disconnected successfully");
      } else {
        message.warning(responseMessage);
      }
    } catch (error) {
      console.error("Error disconnecting device", error);
      message.error("Failed to disconnect device");
    }
  };

  const fetchMasterData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/devices/masters`,
      );
      const playlistData = response.data.data.playlists;
      const screenData = response.data.data.screens;
      setPlaylists(playlistData);
      setScreens(screenData);
      setAssignableScreens(response.data.data.assignable_screens || []);
      setFacilities(
        response.data.data.facilities || { type: "flat", locations: [] },
      );
      setScreenOptions([
        { value: "unassigned", label: "Unassigned Screens" },
        ...screenData.map((screen) => {
          return {
            value: screen.id,
            label: screen.location_name
              ? `${screen.name} (${screen.location_name})`
              : screen.name,
          };
        }),
      ]);
      if (
        queryParams.get("screen") &&
        queryParams.get("screen") !== "" &&
        !isNaN(queryParams.get("screen"))
      ) {
        setScreenSearch(parseInt(queryParams.get("screen")));
      }
      if (
        queryParams.get("city") &&
        queryParams.get("city") !== "" &&
        !isNaN(queryParams.get("city"))
      ) {
        setCitySearch(parseInt(queryParams.get("city")));
      }
      if (
        queryParams.get("location") &&
        queryParams.get("location") !== "" &&
        !isNaN(queryParams.get("location"))
      ) {
        setLocationSearch(parseInt(queryParams.get("location")));
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch master data", error);
      setLoading(false);
    }
  };

  const handleAssignPlaylist = async () => {
    if (!selectedPlaylist) {
      message.error("Please select a playlist");
      return;
    }

    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id],
    );

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-playlist`,
        {
          device_ids: selectedDeviceIds,
          playlist_id: selectedPlaylist,
        },
      );
      message.success("Playlist assigned successfully");
      setAssignModalOpen(false);
      setSelectedPlaylist(null);
      setCurrentPlaylist(null);
      await fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign playlist", error);
      message.error("Failed to assign playlist");
    }
  };

  const handleAssignSinglePlaylist = async () => {
    if (!selectedPlaylist) {
      message.error("Please select a playlist");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-playlist`,
        {
          device_ids: selectedDevice,
          playlist_id: selectedPlaylist,
        },
      );
      message.success("Playlist assigned successfully");
      setAssignPlaylistModalOpen(false);
      setSelectedPlaylist(null);
      setCurrentPlaylist(null);
      await fetchData(); // Refresh playlist list
    } catch (error) {
      console.error("Failed to assign playlist", error);
      message.error("Failed to assign playlist");
    }
  };

  const handleAssignScreen = async () => {
    if (!selectedScreen) {
      message.error("Please select a screen");
      return;
    }

    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id],
    );

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-screen`,
        {
          device_ids: selectedDeviceIds,
          screen_id: selectedScreen,
        },
      );
      message.success("Screen assigned successfully");
      setAssignScreenModalOpen(false);
      setSelectedScreen(null);
      setCurrentScreen(null);
      await fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign screen", error);
      message.error("Failed to assign screen");
    }
  };

  const handleAssignSingleScreen = async () => {
    if (!selectedScreen) {
      message.error("Please select a screen");
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/assign-screen`,
        {
          device_ids: selectedDevice,
          screen_id: selectedScreen,
        },
      );
      message.success("Screen assigned successfully");
      setAssignScreenSingleModalOpen(false);
      setSelectedScreen(null);
      setCurrentScreen(null);
      await fetchData(); // Refresh screen list
    } catch (error) {
      console.error("Failed to assign screen", error);
      message.error("Failed to assign screen");
    }
  };

  const handleAssignDisconnect = async () => {
    const selectedDeviceIds = Object.keys(selectedDevices).filter(
      (id) => selectedDevices[id],
    );

    if (selectedDeviceIds.length === 0) {
      message.warning("No devices selected for disconnection");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/disconnect`,
        {
          device_ids: selectedDeviceIds,
        },
      );
      const { updated_row_count, message: responseMessage } =
        response.data.data;

      await fetchData();
      if (updated_row_count > 0) {
        message.success(
          `${updated_row_count} device(s) disconnected successfully.`,
        );
      } else {
        message.warning(responseMessage);
      }
    } catch (error) {
      console.error("Failed to disconnect device", error);
      message.error("Failed to disconnect device");
    }
  };

  const handleRemovePlaylist = async (record) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/remove-playlist/${record.id}`,
      );
      message.success("Playlist unassigned successfully");
      setSelectedPlaylist(null);
      await fetchData(); // Refresh playlist list
    } catch (error) {
      console.error("Failed to remove playlist", error);
      message.error("Failed to remove playlist");
    }
  };

  const handelViewSubmit = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/devices/updateOrientation`,
        {
          id,
          force_orientation:
            isForceOrientation === null ? "no" : isForceOrientation,
          force_orientation_position:
            isForceOrientation === "yes"
              ? parseInt(isForceOrientationPosition)
              : null,
        },
      );

      const updated_row_count = response.data.data.updated_row_count;
      if (updated_row_count === 0) {
        message.info("No changes made");
      } else if (updated_row_count === 1) {
        message.success("Device updated");
        await fetchData();
      } else {
        message.error("Error updating device");
      }
    } catch (error) {
      console.error("Error updating device", error);
      message.error("Error updating device");
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/devices`,
        {
          params: {
            filter: filterText, // add filter if needed
            limit: pageSize,
            page: currentPage,
            screen: screenSearch,
            type: typeSearch,
            online: onlineSearch,
            blocked: blockedSearch,
            city: citySearch,
            location: locationSearch,
            orientation: orientationSearch,
            unassigned: deviceTab === "unassigned" ? "1" : "",
          },
        },
      );
      let records = response.data.data.data;
      setTotalRecords(response.data.data.total);
      setUnassignedTotal(response.data.data.unassigned_total || 0);
      setDevices(records);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching devices data", error);
    }
  };

  const fetchLocations = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + `/api/locations`,
        { params: { limit: 1000 } },
      );
      const location = response.data.data.data;
      let city = [];
      for (let i = 0; i < location.length; i++) {
        city.push({
          id: location[i].city_id,
          name: location[i].city_name,
        });
      }
      const uniqueCities = Array.from(
        new Map(city.map((item) => [item.id, item])).values(),
      );
      setLocations(location);
      setCities(uniqueCities);
      if (!citySearch) {
        setLocationOptions(location);
      } else {
        const filteredLocations = location.filter(
          (loc) => loc.city_id === citySearch,
        );
        setLocationOptions(
          filteredLocations.length > 0 ? filteredLocations : location,
        );
      }
    } catch (error) {
      console.error("Error fetching locations", error);
    }
  };

  useEffect(() => {
    fetchLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [citySearch]);

  const handleSyncHeartbeats = async () => {
    try {
      setSyncing(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/devices/sync-heartbeat`,
      );
      const updatedCount = response.data.data.updated_row_count;
      message.success(
        updatedCount > 0
          ? `Synced: ${updatedCount} device(s) marked offline`
          : "Synced: all devices already up to date",
      );
      await fetchData();
    } catch (error) {
      message.error("Failed to sync device heartbeats");
    } finally {
      setSyncing(false);
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userData"));
    setUser(storedUser);
    const permissions = storedUser.permissions;
    setViewPermission(parseInt(permissions["signage.devices_view"]) === 1);
    setEditPermission(parseInt(permissions["signage.devices_edit"]) === 1);
    setDeletePermission(parseInt(permissions["signage.devices_delete"]) === 1);
  }, []);

  useEffect(() => {
    fetchMasterData();
  }, [
    assignModalOpen,
    assignScreenModalOpen,
    assignScreenSingleModalOpen,
    assignPlaylistModalOpen,
  ]);

  useEffect(() => {
    if (selectedDeviceId && logsModalOpen) {
      fetchLogs(selectedDeviceId, logCurrentPage, logPageSize);
    }
  }, [logCurrentPage, logPageSize]);

  useEffect(() => {
    const newQueryParams = {
      type: typeSearch,
      online: onlineSearch,
      blocked: blockedSearch,
      city: citySearch,
      location: locationSearch,
      orientation: orientationSearch,
      screen: screenSearch,
      filter: filterText,
      limit: queryParams.get("limit") ?? 10,
      page: queryParams.get("page") ?? 1,
    };

    // Only navigate if something really changed
    if (
      JSON.stringify(newQueryParams) !==
      JSON.stringify(Object.fromEntries(new URLSearchParams(location.search)))
    ) {
      setQueryParams(newQueryParams);
    }

    setQueryParams(newQueryParams);
    const fetchTimer = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(fetchTimer);
  }, [
    currentPage,
    pageSize,
    filterText,
    screenSearch,
    typeSearch,
    onlineSearch,
    blockedSearch,
    citySearch,
    locationSearch,
    orientationSearch,
    deviceTab,
  ]);

  // Reveal the filter panel automatically whenever any filter is actually
  // applied (including ones restored from the URL on page load), rather
  // than making the user click "Filters" to see which ones are active.
  useEffect(() => {
    if (
      screenSearch ||
      typeSearch ||
      onlineSearch ||
      blockedSearch ||
      citySearch ||
      locationSearch
    ) {
      setShowFilters(true);
    }
  }, [
    screenSearch,
    typeSearch,
    onlineSearch,
    blockedSearch,
    citySearch,
    locationSearch,
  ]);

  const columns = [
    editPermission
      ? {
          title: (
            <Checkbox
              name="selected_device"
              onClick={(e) => handleSelectAllChecked(e)}
              checked={isSelectAllChecked}
            />
          ),
          dataIndex: "id",
          render: (
            text,
            record, // As ant design render function includes like (text,record,index).
          ) => (
            <Checkbox
              name="selected_device"
              value={record.id}
              onChange={(e) =>
                handleSingleCheckboxChange(e, record.id, record.screen_id)
              }
              checked={selectedDevices[record.id] || false}
              onClick={(e) => e.stopPropagation()}
            />
          ),
        }
      : [],
    {
      title: "Device Code",
      dataIndex: "code",
      render: (text) => (text ? <Tag>{text}</Tag> : ""),
    },
    {
      title: "Placement",
      dataIndex: "placement",
      render: (text, record) => (
        <>
          <span>{text || "-"}</span>
          {record.is_blocked === "yes" && (
            <Tooltip title={record.blocked_reason || "Blocked"}>
              <Tag color="volcano" style={{ marginLeft: 6 }}>
                Blocked
              </Tag>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "Screen / Location",
      dataIndex: "screen_name",
      render: (Name, record) => (
        <div>
          <Space>
            <Tooltip title="Edit">
              <Button
                size="small"
                type="text"
                style={{
                  backgroundColor: "transparent",
                  color: Name ? "green" : "red",
                  padding: 0,
                }}
                onClick={() => handleScreen(record)}
              >
                <Tag color={Name ? "green" : "red"}>
                  {Name ? Name : "Screen not connected"}
                </Tag>
              </Button>
            </Tooltip>
            {Name && (
              <Tooltip title="Preview Screen">
                <Button
                  size="small"
                  type="text"
                  icon={<EyeOutlined />}
                  disabled={!record.screen_playlist_id}
                  loading={
                    previewLoading &&
                    previewingPlaylistId === record.screen_playlist_id
                  }
                  onClick={() => handlePreviewPlaylist(record)}
                />
              </Tooltip>
            )}
            {editPermission && (
              <Popconfirm
                title="Are you sure to disconnect this device?"
                onConfirm={() => handleDisconnect(record)}
                okText="Yes"
                cancelText="No"
              >
                <Tooltip title="Disconnect">
                  <Button
                    size="small"
                    type="primary"
                    icon={<DisconnectOutlined />}
                    disabled={record.screen_connection_status !== "connected"}
                  />
                </Tooltip>
              </Popconfirm>
            )}
          </Space>
          <div style={{ marginTop: 4 }}>
            {record.device_location_name ? (
              <Tag color="green">{record.device_location_name}</Tag>
            ) : (
              <Tag color="orange">Unassigned</Tag>
            )}
          </div>
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      // Backend stores "samsung" as-is for Tizen devices (device.service.js's
      // getOrInsertDevice only normalizes it to "tizen" for its own internal
      // version-lookup branching, never rewrites the actual stored/matched
      // value) - just a display-layer relabel here, not a data change.
      // "lg" is already stored as-is (no alias to normalize), just relabeled
      // for consistent casing.
      render: (text) => (
        <Tag>{text === "samsung" ? "Tizen" : text === "lg" ? "LG" : text}</Tag>
      ),
    },
    {
      title: "Screen Orientation",
      dataIndex: "screen_orientation",
      render: (text) =>
        text ? (
          <Tag color={text === "portrait" ? "blue" : "green"}>{text}</Tag>
        ) : (
          ""
        ),
    },
    {
      title: "Force Orientation",
      dataIndex: "is_force_orientation",
      render: (text, record) => (
        <>
          {text ? (
            <Tag size="small" color={text === "yes" ? "green" : "red"}>
              {text}
            </Tag>
          ) : (
            <Tag size="small" color="red">
              no
            </Tag>
          )}
          <br></br>
          {record.is_force_orientation === "yes" && (
            <span className="text-small">
              {record.force_orientation_position === 270
                ? "Portrait Secondary"
                : record.force_orientation_position === 180
                  ? "Landscape Secondary"
                  : record.force_orientation_position === 90
                    ? "Portrait Primary"
                    : "Landscape Primary"}
            </span>
          )}
        </>
      ),
    },
    {
      title: "Playlist",
      dataIndex: "playlist_title",
      render: (playlist_title, record) => (
        <>
          <Tooltip title="Edit">
            <Button
              size="small"
              type="text"
              style={{
                backgroundColor: "transparent",
                color: playlist_title ? "green" : "red",
                padding: 0,
              }}
              disabled={
                record.screen_connection_status === "disconnected"
                  ? true
                  : false
              }
              onClick={() => handleAssign(record)}
            >
              <Tag color={playlist_title ? "green" : "red"}>
                {playlist_title ? playlist_title : "Playlist not assigned"}
              </Tag>
            </Button>
          </Tooltip>
          {record.playlist_title && (
            <Popconfirm
              title="Are you sure to unassign this playlist?"
              onConfirm={() => handleRemovePlaylist(record)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Unassign Playlist">
                <Button size="small" danger style={{ fontSize: 10 }}>
                  <CloseOutlined />
                </Button>
              </Tooltip>
            </Popconfirm>
          )}
        </>
      ),
    },
    {
      title: "Online",
      dataIndex: "is_online",
      render: (isOnline, record) => (
        <>
          <Tag color={isOnline ? "green" : "default"}>
            {isOnline ? "Online" : "Offline"}
          </Tag>
          {record.screen_connection_status !== "connected" && (
            <Tooltip title="Combine with another device at the same location (connected or offline), or a device that reconnected after this one went offline (moves logs across, then removes this one)">
              <Button
                size="small"
                type="text"
                icon={<SwapOutlined />}
                onClick={() => handleOpenMerge(record)}
              />
            </Tooltip>
          )}
          {record.last_connected_at && (
            <span className="text-small">
              <br />
              Last heartbeat:{" "}
              {dayjs(record.last_connected_at).format("DD-MM-YYYY HH:mm")}
            </span>
          )}
          {record.screen_connection_status === "disconnected" &&
            record.disconnected_by !== " " && (
              <span className="text-small">
                <br />
                Disconnected by: {record.disconnected_by}
              </span>
            )}
        </>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm")}
        </span>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      render: (text) => (
        <span className="text-small">
          {text ? dayjs(text).format("DD-MM-YYYY HH:mm") : "Not Updated"}
        </span>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          {user && (
            <>
              {editPermission && (
                <Tooltip title="Edit device (placement, block)">
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleEdit(record)}
                  />
                </Tooltip>
              )}
              {viewPermission && (
                <Tooltip title="View">
                  <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => handleView(record)}
                  />
                </Tooltip>
              )}
              {viewPermission && (
                <Tooltip title="Logs">
                  <Button
                    size="small"
                    icon={<DatabaseOutlined />}
                    onClick={() => handleLogs(record)}
                  />
                </Tooltip>
              )}
              {deletePermission && (
                <Popconfirm
                  title="Are you sure to delete this device?"
                  onConfirm={() => handleDelete(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Tooltip title="Delete">
                    <Button size="small" danger icon={<DeleteOutlined />} />
                  </Tooltip>
                </Popconfirm>
              )}
            </>
          )}
        </Space>
      ),
    },
  ];

  const columnLogs = [
    {
      title: "Screen Name",
      dataIndex: "name",
      key: "name",
      render: (name) => (
        <Tag color={name ? "green" : "red"}>
          {name ? name : "Screen not assigned"}
        </Tag>
      ),
    },
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
      render: (event) => {
        const colors = {
          init: "blue",
          online: "green",
          connect: "green",
          offline: "red",
          disconnect: "orange",
        };
        return (
          <Tag color={colors[event] || "red"}>
            {event.charAt(0).toUpperCase() + event.slice(1).toLowerCase()}
          </Tag>
        );
      },
    },
    {
      title: "Event Time",
      dataIndex: "event_time",
      render: (text) => (
        <span className="text-small">
          {dayjs(text).format("DD-MM-YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: "Actioned By",
      dataIndex: "disconnected_by",
      render: (text, record) =>
        record.disconnected_by !== " " && <Tag color="blue">{text}</Tag>,
    },
  ];

  return (
    <RequirePermission permission="signage.devices_view">
      <div style={{ padding: "1rem" }}>
        <Helmet>
          <title>{`${process.env.REACT_APP_NAME} | Signage TVs`}</title>
        </Helmet>
        <Title level={3} style={{ marginBottom: "1rem" }}>
          Signage TVs
        </Title>
        <Radio.Group
          value={deviceTab}
          buttonStyle="solid"
          className="mb-3"
          onChange={(e) => {
            setDeviceTab(e.target.value);
            setCurrentPage(1);
          }}
        >
          <Radio.Button value="all">All Devices</Radio.Button>
          <Radio.Button value="unassigned">
            Unassigned {unassignedTotal > 0 && `(${unassignedTotal})`}
          </Radio.Button>
        </Radio.Group>
        <div className="d-sm-block d-md-flex justify-content-between mb-3">
          <div>
            <Form layout="inline">
              <Form.Item>
                <Dropdown
                  trigger={["click"]}
                  onClick={(e) => e.preventDefault()}
                  menu={{
                    items: [
                      {
                        key: "assign-playlist",
                        label: "Assign Playlist",
                        disabled:
                          Object.values(selectedDevices).filter(Boolean)
                            .length === 0,
                        onClick: () => setAssignModalOpen(true),
                      },
                      {
                        key: "assign-screen",
                        label: "Assign Screen",
                        disabled:
                          Object.values(selectedDevices).filter(Boolean)
                            .length === 0,
                        onClick: () => setAssignScreenModalOpen(true),
                      },
                      {
                        key: "assign-disconnect",
                        label: "Disconnect Device",
                        disabled:
                          Object.values(selectedDevices).filter(Boolean)
                            .length === 0,
                        onClick: () => {
                          Modal.confirm({
                            title: "Confirm Disconnect",
                            icon: <ExclamationCircleOutlined />,
                            content:
                              "Are you sure you want to disconnect the selected devices?",
                            okText: "Yes, Disconnect",
                            okType: "danger",
                            cancelText: "Cancel",
                            onOk() {
                              handleAssignDisconnect();
                            },
                            onCancel() {
                              console.log("Disconnect operation cancelled");
                            },
                          });
                        },
                      },
                    ],
                  }}
                  disabled={
                    Object.values(selectedDevices).filter(Boolean).length === 0
                  }
                >
                  <Button type="primary">
                    <Space>
                      Actions
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Form.Item>
              <Form.Item>
                <Input.Search
                  placeholder="Search Device"
                  value={filterText}
                  className="me-1"
                  onChange={handleSearch}
                  style={{ width: 200 }}
                />
              </Form.Item>
              <Button
                icon={<FilterOutlined />}
                type={showFilters ? "primary" : "default"}
                onClick={() => setShowFilters((prev) => !prev)}
                style={{ marginRight: "1rem" }}
              >
                Filters
                {(screenSearch ||
                  typeSearch ||
                  onlineSearch ||
                  blockedSearch ||
                  citySearch ||
                  locationSearch) && (
                  <Tag color="blue" style={{ marginLeft: 6, marginRight: 0 }}>
                    {
                      [
                        screenSearch,
                        typeSearch,
                        onlineSearch,
                        blockedSearch,
                        citySearch,
                        locationSearch,
                      ].filter(Boolean).length
                    }
                  </Tag>
                )}
              </Button>
              <Form.Item>
                <Tooltip title="Refresh device list">
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={fetchData}
                    loading={loading}
                  >
                    Refresh
                  </Button>
                </Tooltip>
              </Form.Item>
              <Form.Item>
                <Tooltip title="Manually sync device heartbeats now (also runs automatically on every refresh)">
                  <Button
                    icon={<SyncOutlined spin={syncing} />}
                    onClick={handleSyncHeartbeats}
                    loading={syncing}
                  >
                    Sync
                  </Button>
                </Tooltip>
              </Form.Item>
            </Form>
            <Form layout="inline" style={{ marginTop: "1rem" }}>
              {showFilters && (
                <Form.Item label="Screen">
                  <Select
                    value={screenSearch}
                    onChange={(e) => handleScreenChange(e)}
                    onClick={async () => {
                      await fetchMasterData();
                    }}
                    style={{ width: 300 }}
                    showSearch
                    filterOption={(input, option) => {
                      // Fix 5: Better filter logic
                      return (option?.label ?? "")
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }}
                    allowClear
                    options={screenOptions}
                  ></Select>
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item label="Type">
                  <Select
                    value={typeSearch}
                    onChange={(e) => handleTypeChange(e)}
                    style={{ width: 150 }}
                    showSearch
                    filterOption={(input, option) => {
                      return (option?.children ?? "")
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }}
                    allowClear
                  >
                    <Option value="android">Android</Option>
                    <Option value="samsung">Tizen</Option>
                    <Option value="lg">LG</Option>
                    <Option value="browser">Browser</Option>
                  </Select>
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item label="Connection Status">
                  <Select
                    value={onlineSearch}
                    onChange={(e) => handleOnlineChange(e)}
                    style={{ width: 150 }}
                    showSearch
                    filterOption={(input, option) => {
                      // Fix 5: Better filter logic
                      return (option?.children ?? "")
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }}
                    allowClear
                  >
                    <Option value="1">Online</Option>
                    <Option value="0">Offline</Option>
                  </Select>
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item label="Blocked Status">
                  <Select
                    value={blockedSearch}
                    onChange={(e) => handleBlockedChange(e)}
                    style={{ width: 150 }}
                    allowClear
                  >
                    <Option value="1">Blocked</Option>
                    <Option value="0">Unblocked</Option>
                  </Select>
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item
                  label="City"
                  style={{
                    marginTop: window.innerWidth < 1500 ? "1rem" : "0",
                  }}
                >
                  <CityFilter
                    cities={cities}
                    citySearch={citySearch}
                    handleCityChange={handleCityChange}
                  />
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item
                  label="Location"
                  style={{ marginTop: window.innerWidth < 1500 ? "1rem" : "0" }}
                >
                  <LocationFilter
                    locationOptions={locationOptions}
                    locationSearch={locationSearch}
                    handleLocationChange={handleLocationChange}
                    includeUnassignedOption
                  />
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item label="Screen Orientation">
                  <Select
                    value={orientationSearch}
                    onChange={(e) => handleOrientationChange(e)}
                    style={{ width: 150 }}
                    allowClear
                  >
                    <Option value="landscape">Landscape</Option>
                    <Option value="portrait">Portrait</Option>
                  </Select>
                </Form.Item>
              )}
              {showFilters && (
                <Form.Item style={{ marginLeft: "auto", alignSelf: "flex-end" }}>
                  <ClearFiltersButton onClick={handleClearFilters} />
                </Form.Item>
              )}
            </Form>
          </div>
        </div>

        <Table
          loading={loading}
          columns={columns}
          dataSource={devices}
          scroll={{ x: "max-content" }}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} devices`,
            showSizeChanger: true, // Enables the page size selection dropdown
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
          }}
        />
        {isModalOpen && (
          <DeviceForm
            isModalOpen={isModalOpen}
            editingScreen={editingDevice}
            closeModal={() => setIsModalOpen(false)}
            handleUpdateList={fetchData}
            facilities={facilities}
          />
        )}
        <Modal
          title="Combine Device"
          open={mergeModalOpen}
          onCancel={handleCloseMerge}
          onOk={handleConfirmMerge}
          okText="Combine"
          okButtonProps={{
            disabled: !selectedMergeTarget,
            loading: mergeSubmitting,
          }}
          confirmLoading={mergeSubmitting}
        >
          <p>
            Combining moves all logs from{" "}
            <Tag>{mergeSourceDevice?.code || "-"}</Tag>
            into the device selected below, then removes this offline
            device from the list.
          </p>
          {mergeCandidatesLoading ? (
            <Spin />
          ) : mergeCandidates.length === 0 ? (
            <p className="text-danger">
              No eligible devices found. A target device must either share
              this device's location (connected or offline - this device
              currently has{" "}
              {mergeSourceDevice?.device_location_name
                ? `a location assigned (${mergeSourceDevice.device_location_name})`
                : "no location assigned"}
              ), or be currently connected and registered after this device
              was last connected (
              {mergeSourceDevice?.last_connected_at
                ? formatIST(mergeSourceDevice.last_connected_at)
                : "never"}
              ).
            </p>
          ) : (
            <Select
              style={{ width: "100%" }}
              placeholder="Select a device to combine into"
              value={selectedMergeTarget}
              onChange={setSelectedMergeTarget}
              showSearch
              filterOption={(input, option) =>
                (option?.children ?? "")
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {mergeCandidates.map((candidate) => (
                <Option key={candidate.id} value={candidate.id}>
                  {candidate.code || "-"}
                  {candidate.screen_name ? ` - ${candidate.screen_name}` : ""}
                  {" ("}
                  {candidate.screen_connection_status === "connected"
                    ? "Connected"
                    : "Offline"}
                  {", created "}
                  {formatIST(candidate.created_at)}
                  {")"}
                </Option>
              ))}
            </Select>
          )}
        </Modal>
        <Modal
          title="Assign Playlist"
          open={assignModalOpen}
          onCancel={() => {
            setAssignModalOpen(false);
            setSelectedPlaylist(null);
            setCurrentPlaylist(null);
          }}
          width={{
            xs: "80%",
            sm: "70%",
            md: "60%",
            lg: "50%",
            xl: "40%",
            xxl: "30%",
          }}
          maskClosable={false}
          onOk={() => {
            handleAssignPlaylist();
          }}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedPlaylist || selectedPlaylist === currentPlaylist,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Playlist"
            value={selectedPlaylist}
            onChange={(value) => setSelectedPlaylist(value)}
          >
            {playlists.map((playlist) => (
              <Select.Option key={playlist.id} value={playlist.id}>
                {playlist.title}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Playlist"
          open={assignPlaylistModalOpen}
          onCancel={() => {
            setAssignPlaylistModalOpen(false);
            setSelectedPlaylist(null);
            setCurrentPlaylist(null);
          }}
          width={{
            xs: "80%",
            sm: "70%",
            md: "60%",
            lg: "50%",
            xl: "40%",
            xxl: "30%",
          }}
          maskClosable={false}
          onOk={handleAssignSinglePlaylist}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedPlaylist || selectedPlaylist === currentPlaylist,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Playlist"
            value={selectedPlaylist}
            onChange={(value) => setSelectedPlaylist(value)}
          >
            {playlists.map((playlist) => (
              <Select.Option key={playlist.id} value={playlist.id}>
                {playlist.title}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Screen"
          open={assignScreenModalOpen}
          onCancel={() => {
            setAssignScreenModalOpen(false);
            setSelectedScreen(null);
            setCurrentScreen(null);
          }}
          width={{
            xs: "80%",
            sm: "70%",
            md: "60%",
            lg: "50%",
            xl: "40%",
            xxl: "30%",
          }}
          maskClosable={false}
          onOk={() => {
            handleAssignScreen();
          }}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedScreen || selectedScreen === currentScreen,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Screen"
            value={selectedScreen}
            onChange={(value) => setSelectedScreen(value)}
            showSearch
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {assignableScreens.map((screen) => (
              <Select.Option key={screen.id} value={screen.id}>
                {screen.name}
                {screen.location_name ? ` (${screen.location_name})` : ""}
                {screen.orientation
                  ? ` — ${screen.orientation.charAt(0).toUpperCase()}${screen.orientation.slice(1)}`
                  : ""}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="Assign Screen"
          open={assignScreenSingleModalOpen}
          onCancel={() => {
            setAssignScreenSingleModalOpen(false);
            setSelectedScreen(null);
            setCurrentScreen(null);
          }}
          width={{
            xs: "80%",
            sm: "70%",
            md: "60%",
            lg: "50%",
            xl: "40%",
            xxl: "30%",
          }}
          maskClosable={false}
          onOk={handleAssignSingleScreen}
          okText="Assign"
          okButtonProps={{
            disabled: !selectedScreen || selectedScreen === currentScreen,
          }}
        >
          <Select
            style={{ width: "100%" }}
            placeholder="Select a Screen"
            value={selectedScreen}
            onChange={(value) => setSelectedScreen(value)}
            showSearch
            filterOption={(input, option) =>
              (option?.children ?? "")
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {assignableScreens.map((screen) => (
              <Select.Option key={screen.id} value={screen.id}>
                {screen.name}
                {screen.location_name ? ` (${screen.location_name})` : ""}
                {screen.orientation
                  ? ` — ${screen.orientation.charAt(0).toUpperCase()}${screen.orientation.slice(1)}`
                  : ""}
              </Select.Option>
            ))}
          </Select>
        </Modal>
        <Modal
          title="View Device"
          open={isViewModalOpen}
          onCancel={() => {
            setIsViewModalOpen(false);
          }}
          width={{
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "60%",
            xl: "50%",
            xxl: "40%",
          }}
          footer={null}
        >
          {loading ? (
            <Spin />
          ) : (
            detail && (
              <form
                onSubmit={(e) => {
                  handelViewSubmit(detail.id);
                  e.preventDefault();
                  setIsViewModalOpen(false);
                }}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
                onReset={() => {
                  handelViewSubmit(detail.id);
                  setIsViewModalOpen(false);
                }}
              >
                <Descriptions bordered column={1} size="small">
                  <Descriptions.Item label="ID">
                    {detail.uuid.toUpperCase()}
                  </Descriptions.Item>
                  <Descriptions.Item label="Name">
                    {detail.type}
                  </Descriptions.Item>
                  <Descriptions.Item label="Placement">
                    {detail.placement || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Device Code">
                    {detail.code || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Block Status">
                    {detail.is_blocked === "yes" ? (
                      <>
                        <Tag color="volcano">Blocked</Tag>
                        {detail.blocked_reason && (
                          <div className="text-small">
                            Reason: {detail.blocked_reason}
                          </div>
                        )}
                        {detail.blocked_at && (
                          <div className="text-small">
                            Blocked at: {formatIST(detail.blocked_at)}
                          </div>
                        )}
                      </>
                    ) : (
                      <Tag color="green">Not Blocked</Tag>
                    )}
                  </Descriptions.Item>
                  {detail.type !== "browser" && (
                    <Descriptions.Item label="Tizen ID">
                      {detail.tizen_id}
                    </Descriptions.Item>
                  )}
                  <Descriptions.Item label="Platform">
                    {detail.platform_name}
                  </Descriptions.Item>
                  {detail.type === "browser" && (
                    <Descriptions.Item label="User Agent">
                      {detail.user_agent || "-"}
                    </Descriptions.Item>
                  )}
                  {detail.type !== "browser" && (
                    <>
                      <Descriptions.Item label="Processor">
                        {detail.platform_processor}
                      </Descriptions.Item>
                      <Descriptions.Item label="Model">
                        {detail.model_name}
                      </Descriptions.Item>
                      <Descriptions.Item label="Network Push">
                        {detail.network_push}
                      </Descriptions.Item>
                      <Descriptions.Item label="Build Date">
                        {detail.build_date}
                      </Descriptions.Item>
                      <Descriptions.Item label="Build String">
                        {detail.build_string}
                      </Descriptions.Item>
                      <Descriptions.Item label="Manufacturer">
                        {detail.manufacturer
                          ? detail.manufacturer.charAt(0).toUpperCase() +
                            detail.manufacturer.slice(1)
                          : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Build ID">
                        {detail.build_id}
                      </Descriptions.Item>
                      <Descriptions.Item label="Firmware API">
                        {detail.firmware_api}
                      </Descriptions.Item>
                    </>
                  )}
                  <Descriptions.Item label="Resolution">{`${detail.resolution_width} × ${detail.resolution_height}`}</Descriptions.Item>
                  {detail.type !== "browser" && (
                    <>
                      <Descriptions.Item label="Screen Size">{`${detail.physical_width} × ${detail.physical_height}`}</Descriptions.Item>
                      <Descriptions.Item label="DPI">{`${detail.dpi_width} × ${detail.dpi_height}`}</Descriptions.Item>
                      <Descriptions.Item label="Brightness">
                        {detail.brightness}
                      </Descriptions.Item>
                      <Descriptions.Item label="Wifi">
                        {
                          <Card bodyStyle={{ padding: 0 }} bordered={false}>
                            <Descriptions
                              bordered
                              column={1}
                              size="small"
                              labelStyle={{ fontWeight: 600, width: "180px" }}
                            >
                              <Descriptions.Item label="Status">
                                {detail.wifi_status === "ON" ? (
                                  <Tag color="green">ON</Tag>
                                ) : (
                                  <Tag color="red">OFF</Tag>
                                )}
                              </Descriptions.Item>
                              <Descriptions.Item label="SSID">
                                {detail.wifi_ssid || "N/A"}
                              </Descriptions.Item>
                              <Descriptions.Item label="IP Address">
                                {detail.wifi_ip_address || "N/A"}
                              </Descriptions.Item>
                              <Descriptions.Item label="IPv6 Address">
                                {detail.wifi_ipv6_address || "N/A"}
                              </Descriptions.Item>
                              <Descriptions.Item label="MAC Address">
                                <Text code>
                                  {detail.wifi_mac_address || "N/A"}
                                </Text>
                              </Descriptions.Item>
                              <Descriptions.Item label="Signal Strength">
                                {detail.wifi_signal_strength
                                  ? `${detail.wifi_signal_strength}`
                                  : "N/A"}
                              </Descriptions.Item>
                            </Descriptions>
                          </Card>
                        }
                      </Descriptions.Item>
                      <Descriptions.Item label="Ethernet">
                        {
                          <Card bodyStyle={{ padding: 0 }} bordered={false}>
                            <Descriptions
                              bordered
                              column={1}
                              size="small"
                              labelStyle={{ fontWeight: 600, width: "180px" }}
                            >
                              <Descriptions.Item label="Cable">
                                {detail.ethernet_cable === "ATTACHED" ? (
                                  <Tag color="green">ATTACHED</Tag>
                                ) : (
                                  <Tag color="red">DETACHED</Tag>
                                )}
                              </Descriptions.Item>
                              <Descriptions.Item label="Status">
                                {detail.ethernet_status === "CONNECTED" ? (
                                  <Tag color="green">CONNECTED</Tag>
                                ) : (
                                  <Tag color="red">DISCONNECTED</Tag>
                                )}
                              </Descriptions.Item>
                              <Descriptions.Item label="IP Address">
                                {detail.ethernet_ip_address || "N/A"}
                              </Descriptions.Item>
                              <Descriptions.Item label="IPv6 Address">
                                {detail.ethernet_ipv6_address || "N/A"}
                              </Descriptions.Item>
                              <Descriptions.Item label="MAC Address">
                                <Text code>
                                  {detail.ethernet_mac_address || "N/A"}
                                </Text>
                              </Descriptions.Item>
                            </Descriptions>
                          </Card>
                        }
                      </Descriptions.Item>
                      <Descriptions.Item label="Orientation">
                        {detail.orientation}
                      </Descriptions.Item>
                    </>
                  )}
                  {detail && (
                    <Descriptions.Item label="Force Orientation">
                      <Radio.Group
                        onChange={handleForceOrientationChange}
                        value={isForceOrientation}
                      >
                        <Radio value="yes">Yes</Radio>
                        <Radio value="no">No</Radio>
                      </Radio.Group>
                      <br></br>
                      {isForceOrientation === "yes" && (
                        <Select
                          placeholder="Select Orientation Position"
                          style={{ marginTop: 8, minWidth: 200 }}
                          value={obj[isForceOrientationPosition]}
                          onChange={handleForceOrientationPositionChange}
                        >
                          <Option value="0">Landscape Primary</Option>
                          <Option value="90">Portrait Primary</Option>
                          <Option value="180">Landscape Secondary</Option>
                          <Option value="270">Portrait Secondary</Option>
                        </Select>
                      )}
                    </Descriptions.Item>
                  )}

                  {detail.type !== "browser" && (
                    <>
                      <Descriptions.Item label="Auto Rotation">
                        {detail.is_auto_rotation === "1" ? (
                          <Tag color="green">Enable</Tag>
                        ) : (
                          <Tag color="red">Disable</Tag>
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item label="Device Location">
                        <>
                          <span>{detail.device_location_source}</span>
                          <Button
                            size="small"
                            onClick={() =>
                              handleOpenMap(
                                detail.device_lat,
                                detail.device_lng,
                              )
                            }
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              boxShadow: "none",
                              color: "blue",
                              position: "relative",
                              top: "2px",
                              left: "5px",
                            }}
                          >
                            <img
                              src="https://icons.veryicon.com/png/o/photographic/ant-design-official-icon-library/location-37.png"
                              alt="Device Location"
                              style={{ width: "15px", height: "15px" }}
                            />
                          </Button>
                        </>
                      </Descriptions.Item>
                      <Descriptions.Item label="Device Time">
                        {detail.device_time}
                      </Descriptions.Item>
                    </>
                  )}
                  <Descriptions.Item label="Screen">
                    {
                      screens.find((screen) => screen.id === detail.screen_id)
                        ?.name
                    }
                  </Descriptions.Item>
                  <Descriptions.Item label="Playlist">
                    {
                      playlists.find(
                        (playlist) => playlist.id === detail.playlist_id,
                      )?.title
                    }
                  </Descriptions.Item>
                  <Descriptions.Item label="Connection Status">
                    <span>
                      {detail.screen_connection_status
                        ? detail.screen_connection_status
                            .charAt(0)
                            .toUpperCase() +
                          detail.screen_connection_status.slice(1)
                        : "Init"}
                    </span>
                    <br></br>
                    <span>By</span>
                    &nbsp;
                    <span style={{ fontWeight: "bolder" }}>
                      {detail.disconnected_by}
                    </span>
                    <br></br>
                    <span>At</span>
                    &nbsp;
                    <span style={{ fontWeight: "bolder" }}>
                      {formatIST(detail.last_disconnected_at)}
                    </span>
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Connected">
                    {formatIST(detail.last_connected_at)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {formatIST(detail.created_at)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Updated At">
                    {formatIST(detail.updated_at)}
                  </Descriptions.Item>
                </Descriptions>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    // disable if no selection
                    (isForceOrientation === "yes" &&
                      isForceOrientationPosition === null) ||
                    // disable if nothing changed
                    detail.is_force_orientation === null ||
                    (isForceOrientation === detail.is_force_orientation &&
                      isForceOrientationPosition ===
                        detail.force_orientation_position)
                  }
                >
                  Submit
                </Button>
              </form>
            )
          )}
        </Modal>
        <Modal
          title={
            <Space>
              <span style={{ fontWeight: 600 }}>Device Logs</span>
              <Tag color="blue">
                ID:
                {selectedDeviceId &&
                  devices
                    .find((device) => device.id === selectedDeviceId)
                    ?.uuid.toString()}
              </Tag>
            </Space>
          }
          onCancel={() => {
            setLogsModalOpen(false);
            setSelectedDeviceId(null);
            setEventFilter(null);
            setDateRange([]);
            setLogCurrentPage(1);
            setLogPageSize(10);
            setLogs([]);
            setTotalLogRecords(0);
          }}
          open={logsModalOpen}
          width={{
            xs: "90%",
            sm: "80%",
            md: "70%",
            lg: "60%",
            xl: "50%",
            xxl: "40%",
          }}
          footer={null}
        >
          <Space
            style={{
              marginBottom: 16,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <RangePicker
              value={dateRange}
              onChange={(dates) => setDateRange(dates || [])}
            />
            <Select
              placeholder="Filter by Event"
              value={eventFilter}
              style={{ width: 150 }}
              allowClear
              onChange={(value) => setEventFilter(value)}
            >
              <Option value="online">Online</Option>
              <Option value="init">Init</Option>
              <Option value="offline">Offline</Option>
              <Option value="connect">Connect</Option>
              <Option value="disconnect">Disconnect</Option>
            </Select>
            <Button
              type="primary"
              onClick={() => {
                setLogCurrentPage(1);
                fetchLogs(selectedDeviceId, 1, logPageSize);
              }}
            >
              Apply Filters
            </Button>
          </Space>

          <Table
            loading={loading}
            columns={columnLogs}
            dataSource={logs}
            scroll={{ x: "max-content" }}
            rowKey={(record) => record.id}
            onChange={handleLogTableChange}
            pagination={{
              current: logCurrentPage,
              pageSize: logPageSize,
              total: totalLogRecords,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} logs`,
              showSizeChanger: true, // Enables the page size selection dropdown
              pageSizeOptions: ["5", "10", "20", "50", "100"], // Options for the page size selection
            }}
          />
        </Modal>
        {isPreviewModalOpen && (
          <PreviewPlaylist
            isModalOpen={isPreviewModalOpen}
            closeModal={() => setIsPreviewModalOpen(false)}
            playlist={previewPlaylist}
          />
        )}
      </div>
    </RequirePermission>
  );
};

export default Devices;
